import { extend } from 'sk-ui/lib/utils/util.js'

import limit from '@/store/modules/limitMng/metaData/limit'
export default {
  FeatureLimitCreate({ commit }, params) {
    const props = {
      params: { specId: params.rowId },
      extraParams: {
        featureName: params.row.featureName
      }
    }
    const limitCreate = extend(true, {}, limit)
    limitCreate.toolbar.items[1].label = '  当前功能：' + params.row.featureName
    this.dispatch('OpenDetailDialog', {
      metaData: limitCreate,
      props
    })
  }
}
